import { Injectable } from '@angular/core';
import { TextColumnComponent } from './text-column/text-column.component';
import { DateTimeColumnComponent } from './date-time-column/date-time-column.component';
import { MultiPicklistColumnComponent } from './multi-picklist-column/multi-picklist-column.component';
import { PicklistColumnComponent } from './picklist-column/picklist-column.component';
import { UrlColumnComponent } from './url-column/url-column.component';
import { NumberColumnComponent } from './number-column/number-column.component';
import { UidColumnComponent } from './uid-column/uid-column.component';
import { UserColumnComponent } from './user-column/user-column.component';
import { GeometryColumnComponent } from './geometry-column/geometry-column.component';
import { FieldDataType } from '../../store/models/document.model';
import { ImageColumnComponent } from './image-column/image-column.component';
import { EmailColumnComponent } from './email-column/email-column.component';
import { PhoneColumnComponent } from './phone-column/phone-column.component';
import { ReferenceColumnComponent } from './reference-column/reference-column.component';
import { AutoIncrementColumnComponent } from './auto-increment-column/auto-increment-column.component';
import { ArrayColumnComponent } from './array-column/array-column.component';
import { CultureCodeColumnComponent } from './culture-code-column/culture-code-column.component';
import { EnumerationColumnComponent } from './enumeration-column/enumeration-column.component';
import { BusinessUnitsColumnComponent } from './business-units-column/business-units-column.component';

@Injectable({ providedIn: 'root' })
export class ColumnTypeMapService {
  public columnTypeMap: any = {};

  constructor() {
    this.columnTypeMap[FieldDataType.Text] = TextColumnComponent;
    this.columnTypeMap[FieldDataType.DateTime] = DateTimeColumnComponent;
    this.columnTypeMap[FieldDataType.MultiPicklist] = MultiPicklistColumnComponent;
    this.columnTypeMap[FieldDataType.Picklist] = PicklistColumnComponent;
    this.columnTypeMap[FieldDataType.Url] = UrlColumnComponent;
    this.columnTypeMap[FieldDataType.Number] = NumberColumnComponent;
    this.columnTypeMap[FieldDataType.UId] = UidColumnComponent;
    this.columnTypeMap[FieldDataType.User] = UserColumnComponent;
    this.columnTypeMap[FieldDataType.Geometry] = GeometryColumnComponent;
    this.columnTypeMap[FieldDataType.Image] = ImageColumnComponent;
    this.columnTypeMap[FieldDataType.Email] = EmailColumnComponent;
    this.columnTypeMap[FieldDataType.Phone] = PhoneColumnComponent;
    this.columnTypeMap[FieldDataType.SingleReference] = ReferenceColumnComponent;
    this.columnTypeMap[FieldDataType.RelatedChild] = ReferenceColumnComponent;
    this.columnTypeMap[FieldDataType.RelatedParent] = ReferenceColumnComponent;
    this.columnTypeMap[FieldDataType.AutoIncrement] = AutoIncrementColumnComponent;
    this.columnTypeMap[FieldDataType.Array] = ArrayColumnComponent;
    this.columnTypeMap[FieldDataType.CultureCode] = CultureCodeColumnComponent;
    this.columnTypeMap[FieldDataType.Enumeration] = EnumerationColumnComponent;
    this.columnTypeMap[FieldDataType.BusinessUnits] = BusinessUnitsColumnComponent;
  }

  getComponentByDataType(datType: number): any {
    return this.columnTypeMap[datType];
  }
}
